"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const _1 = require("../.");
/**
 * A list of checkboxes, where user can pick multiple options.
 */
const CheckboxList = ({ name, value, mandatory, setValue, options, small, }) => {
    const classes = (0, _1.useCheckboxStyles)();
    return (react_1.default.createElement("div", null, options.map((option, index) => {
        const { optionLabel, optionValue } = (0, _1.parseOption)(option);
        const checked = (value && value.includes(optionValue));
        return (react_1.default.createElement("label", { className: (0, classnames_1.default)(classes.label, 'rfc-checkitem', { [classes.small]: small }), htmlFor: `${name}${index}`, key: index },
            react_1.default.createElement("input", { type: 'checkbox', name: `${name}${index}`, className: classes.input, id: `${name}${index}`, checked: checked, onChange: () => {
                    const finalValue = (0, _1.checkboxHandler)(!checked, optionValue, value);
                    setValue(name, finalValue, mandatory, { touched: true });
                } }),
            " ",
            optionLabel));
    })));
};
exports.default = (0, _1.withFormControl)(CheckboxList);
